export const VENDOR_FETCHING = 'VENDOR_FETCHING';
export const VENDOR_FETCH = 'VENDOR_FETCH';
export const VENDOR_FETCH_ERROR = 'VENDOR_FETCH_ERROR';
export const VENDOR_CLEAR = 'VENDOR_CLEAR';
export const VENDOR_SUBMITTING = 'VENDOR_SUBMITTING';
export const VENDOR_SUBMIT = 'VENDOR_SUBMIT';
export const VENDOR_SUBMIT_ERROR = 'VENDOR_SUBMIT_ERROR';
export const VENDOR_CLEAR_ERROR_SUCCESS = 'VENDOR_CLEAR_ERROR_SUCCESS';
export const VENDOR_DELETING = 'VENDOR_DELETING';
export const VENDOR_DELETE = 'VENDOR_DELETE';
export const VENDOR_DELETE_ERROR = 'VENDOR_DELETE_ERROR';



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/vendorDetails/types.js